import React from 'react';
import { motion } from 'framer-motion';

const LinkBuilding = () => {
  const authorityLinks = [
    {
      title: 'Cybersecurity Insights',
      url: 'https://www.cisa.gov/cybersecurity-best-practices',
      description: 'CISA Cybersecurity Best Practices',
      rel: 'noopener noreferrer'
    },
    {
      title: 'Domain Security Standards',
      url: 'https://www.icann.org/resources/pages/domain-security-2017-06-06-en',
      description: 'ICANN Domain Security Guidelines',
      rel: 'noopener noreferrer'
    },
    {
      title: 'Enterprise DNS Solutions',
      url: 'https://www.cloudflare.com/dns/',
      description: 'Cloudflare DNS Infrastructure',
      rel: 'noopener noreferrer'
    },
    {
      title: 'Email Security Framework',
      url: 'https://www.nist.gov/cybersecurity',
      description: 'NIST Cybersecurity Framework',
      rel: 'noopener noreferrer'
    }
  ];

  const industryPartners = [
    {
      name: 'Cloudflare',
      url: 'https://www.cloudflare.com',
      description: 'Global DNS and Security Partner'
    },
    {
      name: 'Xcitium',
      url: 'https://www.xcitium.com',
      description: 'Cybersecurity Technology Partner'
    },
    {
      name: 'ICANN',
      url: 'https://www.icann.org',
      description: 'Domain Name System Authority'
    }
  ];

  return (
    <section className="py-16 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl font-bold text-slate-900 mb-4">
            Industry Authority & Partnerships
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Backed by industry-leading organizations and cybersecurity authorities
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12">
          {/* Authority Links */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <h3 className="text-xl font-semibold text-slate-900 mb-6">
              Cybersecurity Resources
            </h3>
            <div className="space-y-4">
              {authorityLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.url}
                  target="_blank"
                  rel={link.rel}
                  className="block p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200"
                >
                  <h4 className="font-medium text-slate-900 mb-1">{link.title}</h4>
                  <p className="text-sm text-slate-600">{link.description}</p>
                </a>
              ))}
            </div>
          </motion.div>

          {/* Industry Partners */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: true }}
          >
            <h3 className="text-xl font-semibold text-slate-900 mb-6">
              Technology Partners
            </h3>
            <div className="space-y-4">
              {industryPartners.map((partner, index) => (
                <a
                  key={index}
                  href={partner.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200"
                >
                  <h4 className="font-medium text-slate-900 mb-1">{partner.name}</h4>
                  <p className="text-sm text-slate-600">{partner.description}</p>
                </a>
              ))}
            </div>
          </motion.div>
        </div>

        {/* Press & Media */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          viewport={{ once: true }}
          className="mt-16 text-center"
        >
          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <h3 className="text-xl font-semibold text-slate-900 mb-4">
              Media & Press Inquiries
            </h3>
            <p className="text-slate-600 mb-6">
              For media inquiries, partnership opportunities, or industry collaboration
            </p>
            <a
              href="mailto:media@namvoro.com"
              className="inline-flex items-center px-6 py-3 bg-emerald-600 text-white font-medium rounded-lg hover:bg-emerald-700 transition-colors duration-200"
            >
              Contact Media Team
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default LinkBuilding;